import { createSelector } from 'reselect';
import moment from 'moment';

import getCurrentOrder from './getCurrentOrder';
import getBuffer from './getBuffer';

import { ASAP_TIME } from '../constants';

const getDeliveryTime = createSelector([getCurrentOrder], order => {
  const saleDetailsEstimatedDeliveryTime =
    order.saleDetails?.estimatedDeliveryTime;
  const orderDeliveryTime = order.deliveryTime;

  let deliveryTime;
  if (saleDetailsEstimatedDeliveryTime) {
    deliveryTime = moment(saleDetailsEstimatedDeliveryTime).format();
  } else if (orderDeliveryTime && orderDeliveryTime !== ASAP_TIME) {
    deliveryTime = moment(order.deliveryTime).format();
  } else {
    deliveryTime = ASAP_TIME;
  }
  return deliveryTime;
});

export default getDeliveryTime;

export const $getDeliveryTime = createSelector([getBuffer], buffer => {
  if (buffer.deliveryTime != null) {
    return moment(buffer.deliveryTime).format();
  }

  return ASAP_TIME;
});
